import React, { useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import useAxios from "axios-hooks";
import PhoneInput from "react-phone-input-2";

import { request } from "../../api";
import { Button, Checkbox, CheckboxInput } from "..";

import ReCAPTCHA from "react-google-recaptcha";

import styles from "./CallbackForm.module.scss";

const CallbackForm = ({ manager, title, className, onSuccess }) => {
  const recaptchaRef = useRef();
  const [captchaAllow, setCaptchaAllow] = useState(true);
  const [captchaError, setCaptchaError] = useState(false);
  const [completedHoneypot, setCompletedHoneypot] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    formState,
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      nameksljf: "",
      companygdsa: "",
      phonehfdb: "",
      emaildtrew: "",
      message: "",
      email: "",
      siteasdfg: "",
      agree: false,
      tasks: [],
    },
  });

  let [{ data: response, loading, error: responseError }, send] = useAxios(
    { url: `${request}/api/send-message`, method: "POST" },
    {
      manual: true,
    }
  );


  const sendForm = async (formData) => {
  if (completedHoneypot) {
    console.error("Заявка отклонена. Honeypot заполнен");
    return;
  }

  const isDisabledCaptcha = true;

  if (!captchaAllow && !isDisabledCaptcha) {
    setCaptchaError(true);
    return;
  }

  setCaptchaError(false);

  try {
    const result = await send({ data: formData });

    if (result?.data?.message === "success") {
      onSuccess?.();
    }
  } catch (e) {
    console.error(e);
  }
};

  const tasks = [
    "Брендинг",
    "Упаковка",
    "Полиграфия",
    "Сайт",
    "Навигация",
    "Интерьер",
    "Выставка",
    "Видео",
  ];


  const onCaptchaChange = () => {
    const recaptchaValue = recaptchaRef.current.getValue();

    setCaptchaAllow(!(recaptchaValue.length === 0))
  };

  return (
    <div className={classNames(styles.CallbackForm, className)}>
      <form className={styles.Form} onSubmit={handleSubmit(sendForm)}>
        <input name="utf8" type="hidden" value="✓" />
        <input
          type="hidden"
          {...register("title", { value: title ? title : "no title" })}
        />
        <input
          type="hidden"
          {...register("manager", { value: manager ? manager : "" })}
        />

        <fieldset className={styles.Checkboxes}>
          {tasks.map((task, index) => {
            return <Checkbox key={index} text={task} register={register} label="tasks" />;
          })}
        </fieldset>

        <fieldset className={styles.Fields}>
          <label className={styles.LabelWrapper}>
            <input
              className={classNames(styles.Input, errors.nameksljf && styles.Error)}
              type="text"
              {...register("nameksljf", {
                required: "Поле обязательно для заполнения",
              })}
            />

            <div
              className={classNames(
                styles.Label,
                formState.touchedFields.nameksljf && styles.LabelSmall
              )}
            >
              Имя
            </div>

            {formState.errors.nameksljf && (
              <p className="error-hint">{formState.errors.nameksljf.message}</p>
            )}
          </label>

          <label className={styles.LabelWrapper}>
            <input
              className={classNames(
                styles.Input,
                errors.companygdsa && styles.Error
              )}
              type="text"
              {...register("companygdsa", {
                required: "Поле обязательно для заполнения",
              })}
            />

            <div
              className={classNames(
                styles.Label,
                formState.touchedFields.companygdsa && styles.LabelSmall
              )}
            >
              Название компании
            </div>

            {formState.errors.companygdsa && (
              <p className="error-hint">{formState.errors.companygdsa.message}</p>
            )}
          </label>

          <label className={styles.LabelWrapper}>
            <Controller
              control={control}
              name="phonehfdb"
              rules={{
                required: "Поле обязательно для заполнения",
                minLength: {
                  value: 11,
                  message: "Некорректный номер телефона",
                },
              }}
              render={({ field: { ref, ...field } }) => (
                <PhoneInput
                  {...field}
                  inputExtraProps={{
                    ref,
                    required: true,
                    autoFocus: true,
                  }}
                  country={"ru"}
                  onlyCountries={["ru"]}
                  disableDropdown={true}
                  inputClass={classNames(
                    styles.Input,
                    errors.phonehfdb && styles.Error
                  )}
                  countryCodeEditable={false}
                  specialLabel=""
                />
              )}
            />

            <div
              className={classNames(
                styles.Label,
                formState.touchedFields.phonehfdb && styles.LabelSmall
              )}
            >
              Номер телефона
            </div>

            {formState.errors.phonehfdb && (
              <p className="error-hint">{formState.errors.phonehfdb.message}</p>
            )}
          </label>

          <label className={styles.LabelWrapper}>
            <input
              className={classNames(styles.Input, errors.emaildtrew && styles.Error)}
              type="email"
              {...register("emaildtrew", {
                required: "Поле обязательно для заполнения",
              })}
            />

            <div
              className={classNames(
                styles.Label,
                formState.touchedFields.emaildtrew && styles.LabelSmall
              )}
            >
              Эл. почта
            </div>

            {formState.errors.emaildtrew && (
              <p className="error-hint">{formState.errors.emaildtrew.message}</p>
            )}
          </label>

          <label className={classNames(styles.LabelWrapper, styles.WidePhild)}>
            <input
              className={classNames(styles.Input, errors.siteasdfg && styles.Error)}
              type="text"
              {...register("siteasdfg")}
            />

            <div
              className={classNames(
                styles.Label,
                formState.touchedFields.siteasdfg && styles.LabelSmall
              )}
            >
              Сайт/соцсети (если есть)
            </div>
          </label>

          <label className={classNames(styles.LabelWrapper, styles.WidePhild)}>
            <textarea
              className={classNames(
                styles.TextArea,
                errors.message && styles.Error
              )}
              rows="2"
              {...register("message", {
                required: "Поле обязательно для заполнения",
              })}
            />

            <div
              className={classNames(
                styles.Label,
                styles.BottomLabel,
                formState.touchedFields.message && styles.LabelSmall
              )}
            >
              Несколько слов о проекте и приблизительный бюджет
            </div>

            {formState.errors.message && (
              <p className="error-hint">{formState.errors.message.message}</p>
            )}
          </label>


            {/* 
                Поле email не отображается на фронте, оно нужно для того что бы отсеить заявки от спам-ботов.
                Боты заполняют поле, несмотря на то что оно скрыто для пользователей
                На бэкенде проверяем, если поле email заполнено значит заявка от бота.
            */}

          <label className={classNames(styles.LabelWrapper, styles.OhNo)}>
            <input
              className={classNames(styles.Input)}
              autoComplete="off"
              tabIndex="-1"
              type="email"
              {...register("email", {
                onChange: () => { setCompletedHoneypot(true) }
              })}
            />

            <div
              className={classNames(
                styles.Label,
                styles.LabelSmall
              )}
            >
              Email
            </div>
          </label>
        </fieldset>

        <div className={styles.ReCaptcha}>
          {/* <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LdyLLYlAAAAAFe5e87BbPExcbGTJd-iXB1VmJb0"
            onChange={onCaptchaChange}
          /> */}
        </div>

        <div className={styles.Messages}>
          {(captchaError || responseError) && !loading && (
            <p className="error-hint">Что-то пошло не так, попробуйте позже.</p>
          )}

          {response && response.message === "success" && !loading && (
            <p className="success-hint">Ваше обращение успешно отправлено!</p>
          )}

          <div className={styles.AgreeWrapper}> 
            <CheckboxInput register={register} label="agree" errors={errors} />

            <p className="loading-hint">
              Я согласен на обработку персональных данных в соответствии с{" "}
              <a href="/pages/privacy-policy" target="_blank">политикой конфиденциальности </a>
              и принимаю
              <a href="/pages/agree" target="_blank"> пользовательское соглашение</a>
            </p>
          </div>

          {formState.errors.agree && (
              <p className="error-hint">{formState.errors.agree.message}</p>
            )}
        </div>

        <Button disabled={loading} type="submit" className={styles.Button}>
          Отправить
        </Button>
      </form>
    </div>
  );
};

export default CallbackForm;
